import {useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'utils/colors'
import { icons } from 'utils/icons'
import { TUserPermissionsData } from 'types/user.types'

import CustomIcon from 'components/icon/CustomIcon'
import CustomText from 'components/text/CustomText'
import Avatar, { AvatarSize } from 'components/avatar/Avatar'
import { useAppSelector, useIsElectron } from 'app/hooks'
import { FixMeLater } from 'types'
import UserCard from 'components/new-message/user-card/UserCard'
import { useCreateConversationMutation, useCreateMeetingConversationMutation } from 'app/services/room.service'
import Loading from 'components/spinner/Loading'
import { useNavigate } from 'react-router-dom'
// import { IRolePermissions, TeamAndChannelPermissions } from 'types/role.types'
// import { isFlagSetIn } from 'utils/helpers/isSetInFlags'
import useInfoModal from 'utils/hooks/useInfoModal'
import { useLazyCreateChannelConferenceQuery } from 'app/services/conference.service'
import { BUTTONS, MODALS, MESSAGES,USER_STATUS } from 'locales/locales'


import {
  CONFERENCE_TYPE_VIDEO
} from 'utils/constants'
import { isArray } from 'lodash'
import UserGroupsModal from 'features/channels/userGroupModal'
import { useCreateConference } from 'utils/hooks/useCreateConference'

interface IMemberProps {
  _id?: string
  fullname?: string
  isUserCardDisplayable?: boolean
  inSearchInput?: boolean
  permissions?: TUserPermissionsData
  isRemove?: boolean
  avatar?: string
  status?: any
  title?:string
  isCollapse?: boolean
  isReadOnlyPermission?: boolean
  isRoomModerator?: boolean
  isArchived?: boolean
  isModerator?: boolean
  isMemberAlready?: boolean
  isAssingMode?: boolean
  isForMeeting?: boolean
  onSelectMember?: () => void
  onRemoveUser?: (isCancel?: boolean) => void
  onShowMemberInfo?: () => void
  onAssingAsModerator?: (isCancel?: boolean, isModerator?: boolean) => void

}

const Member = ({
  _id,
  avatar,
  status,
  title,
  fullname,
  inSearchInput,
  permissions,
  isRemove,
  isCollapse,
  isRoomModerator,
  isModerator: isChannelModerator,
  isArchived,
  isMemberAlready,
  isAssingMode,
  isForMeeting,
  onSelectMember,
  onRemoveUser,
  onAssingAsModerator

}: IMemberProps) => {
  const myId = useAppSelector((state) => state.auth.id)
  const isMe = _id === myId;
  const [isUserGroupsModalVisible, setIsUserGroupsModalVisible] = useState(false);
  const [visibleMemberInfo, setVisibleMemberInfo] = useState<{
    visible: boolean
    data: FixMeLater
  }>({ visible: false, data: {} })
  const navigate = useNavigate()
  const [createConversation] = useCreateConversationMutation()
  const { t } = useTranslation()
  const [visibleCollapse, setVisibleCollapse] = useState(false)
  const {
    openModal: openConferenceModal,
    closeModal: closeConferenceModal,
    Modal: ConferenceModal,
  } = useInfoModal()
  // const [visibleUserCard, setVisibleUserCard] = useState(false);
  // const userPermissions = useAppSelector<IRolePermissions>((state) => state.auth.permissions);
  // const isSystemAdmin = isFlagSetIn([TeamAndChannelPermissions.UPDATE_CHANNEL], userPermissions.teamAndChannel);
  const [windowApi,setWindowApi] = useState<FixMeLater>(null);
  const [createConference] = useLazyCreateChannelConferenceQuery()
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const onToggleVisiblePermission = () => {
    setVisibleCollapse(!visibleCollapse)
  }

  const onHandleRemoveUser = () => {
    onRemoveUser?.(false)
  }

  const onHandleAssingAsModerator = (isModerator:boolean) => {
    onAssingAsModerator?.(false, isModerator)
  }
  const onUsersGrup = (userId: string, fullname: string) => {
    setIsUserGroupsModalVisible(true);
    setSelectedUserId(userId);
    setSelectedUserName(fullname);
  };

  const closeUserGroupsModal = () => {
    setIsUserGroupsModalVisible(false);
  };


  const onCloseMemberInfoCard = () => {
    setVisibleMemberInfo({ visible: false, data: {} })
  }

  const onShowMemberInfoCard = () => {
    setVisibleMemberInfo({
      visible: true,
      data: {
        avatar,
        fullname,
        title,
        _id,
      },
    });
    // setVisibleUserCard(true);
};

  const isElectron = useIsElectron()
  const [createMeetingConversation] = useCreateMeetingConversationMutation()

  const { handleCreateConference } = useCreateConference({
    createConference,
    createMeetingConversation,
    isElectron,
    windowApi,
    closeConferenceModal,
  });

 const onVideoCall = async (userId: string) => {
    openConferenceModal({
      title: t(MODALS.CREATE_VIDEO_CONFERENCE_TITLE),
      description: t(MODALS.CREATE_VIDEO_CONFERENCE_DESCRIPTION),
      cancelTitle: t(BUTTONS.CANCEL) as string,
      okTitle: t(BUTTONS.YES) as string,
      onCancel: closeConferenceModal,
      onOk: () => handleCreateConference(CONFERENCE_TYPE_VIDEO, [myId, userId], null)
    })

}


const onClickChatIcon = async (userId: string): Promise<string | null> => {
  try {
    Loading.ref.show();
    const result = await createConversation({ members: [userId] });
    if (!result.error) {
      const roomId = typeof result.data.data === 'string' ? result.data.data : result.data.data._id;
      navigate('/messages/' + roomId);
      return roomId;
    }
  } catch (error) {
    console.error('Error in creating or fetching conversation:', error);
  } finally {
    Loading.ref.hide();
  }
  return null;
};




  const userRole = isChannelModerator
    ? (isForMeeting ? t(USER_STATUS.MEETING_MODERATOR) : t(USER_STATUS.MODERATOR))
    : null


  return (
    <div>
      <Row inSearchInput={inSearchInput}>
        <MemberLeftWrapper
          inSearchInput={inSearchInput}
          onClick={() => (onSelectMember?.())}
        >
          {visibleMemberInfo.visible && (
        <UserCard
          {...visibleMemberInfo.data}
          showChatIcon={visibleMemberInfo.data._id !== myId}
          showCallIcon={false}
          showCameraIcon={visibleMemberInfo.data._id !== myId}
          isCentered={true}
          onClickUserGroups={() => onUsersGrup(visibleMemberInfo.data._id, visibleMemberInfo.data.fullname)}
          onClickCameraIcon={()=>onVideoCall(visibleMemberInfo.data._id)}
          onClickChatIcon={()=>onClickChatIcon(visibleMemberInfo.data._id)}
        />
         )}
        <div
            onClick={(e) => {
              e.stopPropagation()
              onShowMemberInfoCard()
            }}
          >
          <Avatar
            source={avatar}
            text={fullname }
            size={AvatarSize.average}
            status={status}
          />
          </div>
          <MemberDescriptionWrapper>
            <MemberTitleWrapper>
              <MemberInfoText typography="header3">{fullname}</MemberInfoText>
              {userRole  && (
                <CustomText typography="body7" color={colors.gray80}>
                  ({userRole})
                </CustomText>
              )}
              {isMemberAlready && (
                <CustomText typography="body7" color={colors.gray80}>
                  &bull; {t(MESSAGES.ALREADY_ADDED)}
                </CustomText>
              )}

              {
              isCollapse && permissions && isArray(permissions) && visibleCollapse && !isArchived && (
                <CollapseIcon
                  iconPreset="xSmall"
                  isOpen={visibleCollapse}
                  source={icons.downArrowSmall}
                  onClick={onToggleVisiblePermission}
                />
              )}
            </MemberTitleWrapper>
          </MemberDescriptionWrapper>
        </MemberLeftWrapper>
        {(isRoomModerator ||isRemove ) && (
          <OptionsWrapper>

            {!isMe && isRemove && !isArchived && (
              <CustomText
                typography="body7"
                color={colors.red}
                cursor="pointer"
                onClick={onHandleRemoveUser}
              >
                {t(BUTTONS.REMOVE)}
              </CustomText>
            )}

            {!isMe && !isArchived && isChannelModerator && (
                <CustomText
                  typography="body7"
                  color={colors.red}
                  cursor="pointer"
                  onClick={() => onHandleAssingAsModerator(!isChannelModerator)}
                >
                  {t(BUTTONS.UNASSING_AS_MODERATOR)}
                </CustomText>
              )}

            {!isMe  && !isArchived && !isChannelModerator && isAssingMode && (
              <CustomText
                typography="body7"
                color={colors.red}
                cursor="pointer"
                onClick={() => onHandleAssingAsModerator(!isChannelModerator)}
              >
                {t(BUTTONS.ASSING_AS_MODERATOR)}
              </CustomText>
            )}

          </OptionsWrapper>
        )}
      </Row>
     {visibleMemberInfo.visible && <MemberUserCardBackDrop onClick={onCloseMemberInfoCard} />}
     {ConferenceModal}
     {isUserGroupsModalVisible && selectedUserId && (
      <UserGroupsModal
        onClose={closeUserGroupsModal}
        isVisible={isUserGroupsModalVisible}
        userId={selectedUserId}
        userName={selectedUserName}
        />)}
    </div>
  )
}

export default Member

const Row = styled.div.attrs((props: { inSearchInput?: boolean }) => props)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px ${({ inSearchInput }) => (inSearchInput ? 10 : 0)}px;
  &:hover {
    background-color: ${colors.light50};
  }
`
const MemberUserCardBackDrop = styled.div`
  position: fixed;
  z-index: 3;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  backdrop-filter: blur(1px);
`

const MemberLeftWrapper = styled.div.attrs((props: { inSearchInput?: boolean }) => props)`
  display: flex;
  cursor: pointer;
  column-gap: 4px;
  max-width: ${({ inSearchInput }) => (inSearchInput ? '450' : '480')}px;
`
const MemberDescriptionWrapper = styled.div.attrs((props) => props)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const MemberTitleWrapper = styled.div.attrs((props) => props)`
  display: flex;
  align-items: center;
  column-gap: 10px;
  max-width: '100%';
  @media (max-width: 600px) {
    max-width: '350px';
  }
`

const MemberInfoText = styled(CustomText).attrs((props) => props)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const OptionsWrapper = styled.div.attrs((props) => props)`
  display: flex;
  column-gap: 16px;
`

const CollapseIcon = styled(CustomIcon).attrs((props: { isOpen: boolean }) => props)`
  transition: 300ms all;
  rotate: ${({ isOpen }) => (isOpen ? '180deg' : 'initial')};
`
